
import { AfterContentInit, AfterViewInit, Component, ContentChild, ContentChildren, DoCheck, ElementRef, EventEmitter, Input, NgZone, OnDestroy, OnInit, Output, QueryList, TemplateRef, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { ParameterApi } from 'src/app/services/api-service/parameters/parameter-api';
import { VisGridCheckboxColumnComponent } from '../vis-grid-checkbox-column/vis-grid-checkbox-column.component';
import { SortOrder, VisGridColumnComponent } from '../vis-grid-column/vis-grid-column.component';
import { CdkDragDrop, moveItemInArray, } from '@angular/cdk/drag-drop';
import { MatTable } from '@angular/material/table';
import { FontGreatService } from 'src/app/services/font-great.service';
import { fromEvent, Subscription } from 'rxjs';
import { throttleTime } from 'rxjs/operators';
import { VisGridRowComponent } from '../vis-grid-row/vis-grid-row.component';
import { Sum } from 'src/app/shared/utilities';

declare type GridSelectSetting = {
  enabled: boolean,
  checkboxOnly: boolean,
  mode: 'multiple' | 'single',
};
export declare interface GridData {
  data: any[];
  total: number
};
class GridViewModel {
  data: any;
  styles: any;
  classes: string[];
  deSelect() {
    this.classes = this.classes.filter(x => x != 'selected');
  }
  select() {
    if (!this.classes.includes('selected')) {
      this.classes.push('selected');
    }
  }
}
export declare type VisGirdSelection = {
  selectedRows: {
    dataItem: any
  }[]
}
export declare type VisGridCellClick = {
  isEdited: boolean,
  dataItem: any,
  column: VisGridColumnComponent,
  rowIndex: number
}
export declare type VisGridCellDblClick = VisGridCellClick & {
  event: MouseEvent
}
export declare type VisGridColumnSort = {
  sortOrder: SortOrder,
  column: string
}
@Component({
  selector: 'app-vis-grid',
  templateUrl: './vis-grid.component.html',
  styleUrls: ['./vis-grid.component.css']
})

export class VisGridComponent implements OnInit, AfterContentInit, AfterViewInit, OnDestroy, DoCheck {
  @ContentChildren(VisGridColumnComponent)
  childs: QueryList<VisGridColumnComponent>;
  @ContentChildren(VisGridRowComponent)
  extandRows: QueryList<VisGridRowComponent>;
  @ViewChild('scrollContainer')
  scrollContainer: ElementRef<HTMLDivElement>;

  @ViewChild('paginator')
  paginator: MatPaginator;

  // _originalData: GridData;
  _data: GridData;
  _viewData: GridViewModel[];
  _currentPage: number = 1;
  _totalPages: number = 0;
  private dataSetupTimer: any = null;
  private selectedViewUpdateTimer: any = null;

  /** 是否為滾動載入模式 */
  @Input()
  isScrollToLoadMode: boolean = false;

  /** 資料載入中遮罩 */
  @Input()
  showMask: boolean = false;

  /** 固定header開關 */
  @Input()
  showStickyHead?: boolean = false;

  /** 固定table高TODO:customStyle取代showStickyHeight */
  @Input()
  showStickyHeight?: number = 350;
  _showStickyTableRows?: number = null;
  /** showStickyHead下grid的顯示行數 */
  @Input()
  set showStickyTableRows(r: number) {
    var needReComput = !!this._showStickyTableRows;
    this._showStickyTableRows = r;
    if (needReComput) {
      this.computeRowHeight();
    }
  }
  get showStickyTableRows(): number {
    return this._showStickyTableRows;
  }
  /** 字多折行header開關 */
  @Input()
  showMultiLineHead?: boolean = false;

  /** table寬滿版 */
  @Input()
  tableFullWidth?: string = '';
  get tableCls() {
    var cls = [];
    if (this.tableFullWidth) {
      cls.push(this.tableFullWidth)
    } else {
      if (this.scroll) {
        //卷軸開啟，只鎖定最小寬度 寬度鎖死100%的話scroll匯出不來
        cls.push('min-w-100')
      } else {
        //卷軸沒開啟，鎖定寬度100%容器
        cls.push('w-100')
      }
    }
    if (this.sticky) {
      cls.push('d-table')
    }
    return cls.join(' ')
  }
  /** table固定左欄 */
  @Input()
  sticky?: boolean = false;

  /** 預設選取 flag */
  @Input()
  setDefaultSeclected: boolean = false;

  @Input()
  allowDoubleClick: boolean = false;

  @Input()
  set data(v: GridData | any[]) {
    if (v) {
      if (v instanceof Array) {
        this._data = {
          data: v,
          total: v.length
        };
      } else {
        this._data = <GridData>v;
      }

      if (this._data) {
        // this._currentPage = 0;
        if (!this.isScrollToLoadMode) {
          this._viewData = this._data.data.map((d, i) => this.createGridViewModel(d, i));
        } else {
          this._currentPage = 1;
          this._totalPages = Math.ceil(this._data.data.length / this._pageSize);
          this._viewData = this._data.data
            .slice(0, this._pageSize)
            .map((d, i) => this.createGridViewModel(d, i));
        }
        if (this.dataSetupTimer != null) {
          clearTimeout(this.dataSetupTimer);
        }
        this.dataSetupTimer = setTimeout(() => {
          this.dataSetupTimer = null;
          if (this._showStickyTableRows) {
            this.computeRowHeight();
          }
          this.computePages();
          this.checkPageBtn();
          this.computeColStyle();
          if (this.keepSelectionOnPageChange) {
            // 恢復跨頁選擇
            this.restoreCrossPageSelection();
          } else {
            this.setAll(false, null, false);
          }

          this.cancelSelectedViewUpdate();
          this.syncSelectedKeysToCheckboxColumns();
          // 勾欄有綁field的時候，將selectedKeys內容改成有勾選的資料
          this.resetSelectStatus();
          this.updateSelectedViewNow();
          this.onDataSetted.emit(this._data.total);

        }, 0);
      }
    }
  }

  isSticky(index: number) {
    const field = this.childs?.get(index)?._field;
    const visibleIndex = this.displayedColumns.indexOf(field);
    return this.stickyColumnCount > 0 && visibleIndex >= 0 && visibleIndex < this.stickyColumnCount;
  }
  //[stickyEnd]="isStickyEnd"
  isStickyEnd(index: number) {
    const field = this.childs?.get(index)?._field;
    const visibleIndex = this.displayedColumns.indexOf(field);
    return this.stickyEndColumnCount > 0 && visibleIndex >= (this.displayedColumns.length - this.stickyEndColumnCount);
  }
  @Input() customClass?: string;
  @Input() customStyle?: string;
  // get data():{data:any[],total:number }| any[]{
  //   return this._data;
  // }

  _pageIndex = 0;
  _pageSize: number = 10;
  @Input()
  set pageSize(v: number) {
    this._pageSize = v;
    if (this._pageSize) {
      this._pageIndex = Math.floor(this._skip / this._pageSize);
    }
  };
  get pageSize() {
    return this._pageSize;
  }

  _skip: number;
  @Input()
  set skip(v: number) {
    this._skip = v;
    if (this._pageSize) {
      this._pageIndex = Math.floor(this._skip / this._pageSize);
    }
  };
  get skip(): number {
    return this._skip
  }

  @Input()
  pageable: boolean;

  _selectable = false;
  _selectByCheckOnly = true;
  @Input()
  set selectByCheckOnly(v: boolean) {
    this._selectByCheckOnly = v || false
  };
  @Input()
  set selectable(v: boolean | GridSelectSetting) {
    if (v instanceof Boolean) {
      this._selectable = <boolean>v;
      // this.multiselect = false;
    } else if (v as GridSelectSetting) {
      this._selectable = v['enabled'] ?? true;
      this.multiselect = v['mode'] == 'multiple';
      this._selectByCheckOnly = v['checkboxOnly'] ?? false;
    }
  };
  @Input()
  cancelable: boolean = true;

  /** 黃底的選取依據 field key ，例如：Id */
  @Input()
  kendoGridSelectBy: string = '';
  _selectedKeys: string[] = [];
  @Input()
  set selectedKeys(v: string[]) {
    if (v) {
      this._selectedKeys = v;
      this.updateSelectedView()
      this.syncSelectedKeysToCheckboxColumns();
    }
  };

  private syncSelectedKeysToCheckboxColumns() {
    if (!this.childs || !this._data?.data) {
      return;
    }
    this.childs.forEach(c => {
      if (c instanceof VisGridCheckboxColumnComponent) {
        c.selectedKeys = this._selectedKeys;
        c.selectByKey = this.kendoGridSelectBy;
        this._data.data.forEach((d, i) => {
          c.rowClick(i, d)
        });
      }
    });
  }

  private createGridViewModel(data: any, index: number): GridViewModel {
    const useExtra = data?.useExtraOnly == true;
    return Object.assign(new GridViewModel(), {
      data,
      styles: {
        cursor: this.dragable ? 'grab' : 'default'
      },
      classes: [useExtra ? data.classes : index % 2 ? 'even' : 'odd']
    });
  }
  @Input()
  setChangeClassBy: string = '';
  _changeClassKeys: string[] = [];
  @Input()
  set changeClassKeys(v: string[]) {
    if (v) {
      this._changeClassKeys = v;
      this.updateSelectedView();
    }
  };
  @Input() changeRowClass?: string = '';
  // @Input()
  // rowClass?: (rowData: any, rowIndex?: number) => string | string[];
  // @Input()
  // rowTitle?: (rowData: any, rowIndex?: number) => string;
  @Input()
  setting: {
    checkboxOnly: true,
    mode: 'multiple'
  }
  @Input()
  navigable: boolean;

  @Input()
  dragable: boolean;

  readonly isStaticRow = () => !this.dragable;
  readonly isDraggableRow = () => this.dragable;

  @Input()
  noHeader: boolean;

  /** 欄位寬度超出時是否開啟卷軸 */
  @Input()
  scroll: boolean;

  @Input()
  multiselect: boolean;

  @Input()
  stickyColumnCount = 0;

  @Input()
  stickyEndColumnCount = 0;
  /** 換頁是否清除選項 */
  @Input()
  keepSelectionOnPageChange: boolean = false;
  // 跨頁選擇記憶
  private crossPageSelectedKeys: Set<string> = new Set();

  @Output()
  cdkDragEnded: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  pageChange: EventEmitter<number> = new EventEmitter(false);
  @Output()
  cellClick: EventEmitter<VisGridCellClick> = new EventEmitter(false);
  @Output()
  cellDblClick: EventEmitter<VisGridCellDblClick> = new EventEmitter(false);
  @Output()
  selectionChange: EventEmitter<VisGirdSelection> = new EventEmitter(false);
  @Output()
  selectionDblClickChange: EventEmitter<VisGirdSelection> = new EventEmitter(false);

  @Output()
  sort: EventEmitter<VisGridColumnSort> = new EventEmitter();


  @Input()
  pageBtnCnt = 10;
  pages: number[] = [];
  displayedColumns: string[] = [];
  private displayedColumnsSignature = '';
  _hasPrev = false;
  _hasNext = false;
  _hasPrevTen = false;
  _hasNextTen = false;
  usedIdRand = [];
  @Output()
  onDataSetted: EventEmitter<number> = new EventEmitter();

  @Input()
  isResizeColumn?: boolean = false;

  fontSizeSub: Subscription;
  private scrollSub: Subscription;
  private checkboxSelectionSubs: Subscription[] = [];

  // 用於計算選取數量
  private _cachedSelectionCount: number = 0;
  private _lastDataChange: number = 0;

  constructor(private paramApi: ParameterApi,
    private fontGreatService: FontGreatService,
    private ngZone: NgZone
  ) {
    this.fontSizeSub = this.fontGreatService.onFontGreatChanged.subscribe(g => {
      if (this._showStickyTableRows) {
        this.computeRowHeight();
      }
    });
  }

  @ViewChild('mtable')
  tHeader!: MatTable<any>;
  rowHeightCalculated = false;
  ngOnInit(): void {
    if (this.showStickyTableRows) {
      setTimeout(() => {
        this.computeRowHeight();
      }, 0);
    }
    this.computeColStyle()
  }
  ngOnDestroy(): void {
    this.fontSizeSub.unsubscribe();
    this.scrollSub?.unsubscribe();
    this.clearCheckboxSelectionSubscriptions();
    if (this.dataSetupTimer != null) {
      clearTimeout(this.dataSetupTimer);
    }
    this.cancelSelectedViewUpdate();
  }
  ngAfterViewInit(): void {
    this.computeColStyle()
    this.ngZone.runOutsideAngular(() => {
      this.scrollSub = fromEvent(this.scrollContainer.nativeElement, 'scroll')
        .pipe(throttleTime(50))
        .subscribe((event: Event) => this.onScroll(event));
    });
  }
  @ViewChild(MatTable)
  table: MatTable<any>;
  computeColStyle() {

    if (this.stickyColumnCount > 0) {
      setTimeout(() => {
        // var colLeft = 0;
        // this.childs.forEach((x, i) => {
        //   if (i < this.stickyColumnCount) {
        //     (x._style).position = 'sticky !important';
        //     (x._style).left = colLeft + 'px';
        //     if (x._classFromGrid.indexOf('sticky-column') == -1) {
        //       x._classFromGrid += ' sticky-column'
        //     }
        //     x._style = {...x._style};
        //   }
        //   colLeft += <number>x.width;;
        // })
        this.table.updateStickyColumnStyles();
        if (this.scroll) {

          const visibleWidths = this.childs.filter(column => !column.hide).map(column => <number>column.width);
          this.scrollContainer.nativeElement.querySelector('table').style.setProperty('width', Sum(visibleWidths, x => x) + 'px', 'important');
        }
        //this.table.updateStickyColumnStyles()
      }, 100);
    }
  }
  computeRowHeight() {
    var headerHeight = this.tHeader._headerRowOutlet.elementRef.nativeElement.parentElement.offsetHeight;

    var bodyHeight = this.tHeader._rowOutlet.elementRef.nativeElement.parentElement.clientHeight;
    var rowHeight = this.fontGreatService.getFontGreat() ? 32 : 27; // 字體大小預設行高,應該不止這兩個數字...
    if (this._data?.data?.length) {
      rowHeight = bodyHeight / this._data.data.length;
    }

    // 每行28計 +1消除正好滿行時的scroll
    this.showStickyHeight = this.showStickyTableRows * rowHeight + headerHeight;// + 10;
    this.rowHeightCalculated = true;
  }

  /** 預設選取第一筆 */
  defaultSeclected(val: number): boolean {
    if (this.setDefaultSeclected) {
      if (val == 0) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  // setDefault() {
  //   this.setDefaultSeclected = true;
  // }

  ngAfterContentInit() {
    this.childs.changes.subscribe(() => {
      //console.log('columns changed');
      //處理動態增減欄位
      this.resetColumn()
      this.computeColStyle()
    });
    this.resetColumn();
  }
  ngDoCheck(): void {
    this.syncDisplayedColumns();
  }
  private resetColumn() {
    this.clearCheckboxSelectionSubscriptions();
    //this.columns = [];
    this.childs.forEach(c => {
      var field = c.field;
      if (!field) {
        do {
          field = 'id' + Math.floor(Math.random() * 100);
        } while (this.usedIdRand.includes(field));
        this.usedIdRand.push(field);
      }
      c._width = c.width ? (c.width + '') : ''
      c._field = field;
      if (c instanceof VisGridCheckboxColumnComponent) {
        c.selectedKeys = this._selectedKeys;
        c.selectByKey = this.kendoGridSelectBy;
        this.checkboxSelectionSubs.push(c.checkChanged.subscribe(change => {
          this.onCheckboxSelectionChanged(c, change);
        }));
      }
    });
    this.syncDisplayedColumns();
    this.computePages();
    this.checkPageBtn();
  }

  private clearCheckboxSelectionSubscriptions(): void {
    this.checkboxSelectionSubs.forEach(subscription => subscription.unsubscribe());
    this.checkboxSelectionSubs = [];
  }

  private onCheckboxSelectionChanged(
    column: VisGridCheckboxColumnComponent,
    change: { checked: boolean, data: any }
  ): void {
    if (!column.selectOnCheck || column.checkOnSelect || !change.data) {
      return;
    }

    const key = change.data[this.kendoGridSelectBy];
    const viewData = this.findViewData(key);
    if (change.checked) {
      viewData?.select();
    } else {
      viewData?.deSelect();
    }
    this.triggerSelectionChange();
  }

  private syncDisplayedColumns(): void {
    if (!this.childs) {
      return;
    }
    const visibleColumns = this.childs
      .filter(column => !column.hide && !!column._field)
      .map(column => column._field);
    const signature = visibleColumns.join('\u0000');
    if (signature !== this.displayedColumnsSignature) {
      this.displayedColumnsSignature = signature;
      this.displayedColumns = visibleColumns;
    }
  }
  computePages() {
    if (!this.isScrollToLoadMode) {
      if ((this._data?.total ?? 0) == 0) {
        this.pages = [];
      } else {
        var curPage = this._pageIndex;
        // var totalPage = Math.floor((this._data.total - 1) / this.pageSize) + 1
        var totalPage = (this.pageSize === 0 ? 0 : Math.floor((this._data.total - 1) / this.pageSize)) + 1

        var startPage = curPage == 0 ? 0 : Math.floor((Math.floor((curPage) / this.pageBtnCnt)) * this.pageBtnCnt)
        var pageCount = Math.min(totalPage - startPage, this.pageBtnCnt);

        this.pages = Array(pageCount).fill(1).map((x, i) => i + startPage);
      }
    }
  }

  private onScroll(event: Event) {
    // 滾動載入模式
    if (this.isScrollToLoadMode && this._data?.data && this._currentPage < this._totalPages) {
      const element = event.target as HTMLElement;
      const atBottom = element.scrollHeight - element.scrollTop <= element.clientHeight + 10;
      // Load more data when scrolled to bottom
      if (atBottom) {
        // this.mainLayout.showLoader();
        this.ngZone.run(() => {
          const startIndex = this._viewData.length;
          const endIndex = Math.min(startIndex + this._pageSize, this._data.data.length);
        // 防止超出總頁數
        // var tempData = this._data.data.slice(0, this._pageSize * this._currentPage);
        // console.log('onScroll load more data >>>>>', this._currentPage, tempData.length);
          const nextRows = this._data.data
            .slice(startIndex, endIndex)
            .map((data, index) => this.createGridViewModel(data, startIndex + index));
          if (nextRows.length > 0) {
            this._viewData = [...this._viewData, ...nextRows];
            this._currentPage++;
          }
        });
        // this.mainLayout.hideLoader();
      }
    }
  }

  toPage(ind: number) {
    this.setPage(ind);
  }

  hasNextTen() {
    if (!this.paginator) {
      return false;
    }
    var curPage = this._pageIndex;
    var totalPage = Math.floor((this._data.total - 1) / this.pageSize) + 1;
    return totalPage > (curPage - curPage % this.pageBtnCnt + this.pageBtnCnt);
  }

  toNextTen() {
    if (!this.paginator) {
      return false;
    }
    var curPage = this._pageIndex;
    this.setPage(curPage - curPage % this.pageBtnCnt + this.pageBtnCnt);
  }

  hasPrevTen() {
    if (!this.paginator) {
      return false;
    }
    var curPage = this._pageIndex;
    return curPage >= this.pageBtnCnt;
  }

  toPrevTen() {
    if (!this.paginator) {
      return false;
    }
    var curPage = this._pageIndex;
    this.setPage((curPage - curPage % this.pageBtnCnt) - 1);

  }

  toFirst() {
    this.setPage(0);
  }

  toPrev() {
    this.setPage(this._pageIndex - 1)
  }

  toLast() {
    var totalPage = Math.floor((this._data.total - 1) / this.pageSize);
    this.setPage(totalPage)
  }

  toNext() {
    this.setPage(this._pageIndex + 1)
  }

  hasPrev() {
    if (!this.paginator) {
      return false;
    }

    return this._pageIndex > 0;
  }

  hasNext() {
    if (!this.paginator) {
      return false;
    }
    var totalPage = Math.floor((this._data.total - 1) / this.pageSize) + 1;
    return this._pageIndex < totalPage - 1;
  }

  cssIsCurrent(pgInd) {
    if (pgInd == this._pageIndex) {
      return {
        'backgroundColor': 'var(--main-color)',// ' #3ab0f5',
        'color': 'var(--main-color-font)'//'white'
      }
    }
    return {};
  }

  setPage(index) {
    if (this._pageIndex != index) {
      if (this.keepSelectionOnPageChange) {
        // 儲存當前頁面的選擇到記憶體
        this.saveCrossPageSelection();
      } else {
        // 清空
        this.clearSelect();
      }

      this.emitSelection();
      this.pageChange.emit(index + 1);
      setTimeout(() => {
        this._pageIndex = index;
        this.computePages();
        this.checkPageBtn();
        this.scrollContainer.nativeElement.scrollTo(0, 0);
      }, 0);
    }
  }

  /** 儲存當前頁面的選擇到記憶體 */
  private saveCrossPageSelection() {
    if (!this.keepSelectionOnPageChange || !this._data?.data) {
      return;
    }
    // 取得當前頁面所有項目的鍵值
    const currentPageKeys = this._data.data.map(item => item[this.kendoGridSelectBy]?.toString()).filter(Boolean);

    // 從記憶體中移除當前頁面的所有項目
    currentPageKeys.forEach(key => this.crossPageSelectedKeys.delete(key));

    // 將當前頁面選中的項目加入記憶體
    this._selectedKeys.forEach(key => {
      if (key && key.toString()) {
        this.crossPageSelectedKeys.add(key.toString());
      }
    });
  }

  /** 從記憶體恢復當前頁面的選擇 */
  private restoreCrossPageSelection() {
    if (!this.keepSelectionOnPageChange || !this._data?.data) {
      return;
    }

    // 找出當前頁面中應該被選中的項目
    const currentPageKeys = this._data.data.map(item => item[this.kendoGridSelectBy]?.toString()).filter(Boolean);
    const selectedInCurrentPage = currentPageKeys.filter(key => this.crossPageSelectedKeys.has(key));

    // 恢復選擇狀態
    this._selectedKeys = selectedInCurrentPage;
    this.updateSelectedView();

    // 同步 checkbox 狀態
    setTimeout(() => {
      this.updateCheckboxFields();
      this.selectedKeys = this._selectedKeys; // 觸發 selectedKeys setter
    }, 0);

  }

  /** 更新資料中的 checkbox 欄位 */
  private updateCheckboxFields() {
    if (!this._data?.data || !this.childs) {
      return;
    }

    this.childs.forEach(col => {
      if (col instanceof VisGridCheckboxColumnComponent && col._field) {

        this._data.data.forEach(dataItem => {
          const itemKey = dataItem[this.kendoGridSelectBy]?.toString();
          const shouldBeChecked = this._selectedKeys.includes(itemKey);
          dataItem[col._field] = shouldBeChecked;
        });

        col.selectedKeys = this._selectedKeys;
        col.selectByKey = this.kendoGridSelectBy;
      }
    });
  }

  /** 取得所有跨頁選擇的鍵值 */
  getAllCrossPageSelectedKeys(): string[] {
    if (!this.keepSelectionOnPageChange) {
      return [...this._selectedKeys];
    }

    this.saveCrossPageSelection();

    // 回傳所有跨頁選擇
    return Array.from(this.crossPageSelectedKeys);
  }

  /** 清空所有跨頁選擇 */
  clearAllCrossPageSelection() {
    this.crossPageSelectedKeys.clear();
    this._selectedKeys.splice(0, this._selectedKeys.length);
    this.updateSelectedView();
  }

  /** 取得跨頁選擇的總數量 */
  getCrossPageSelectionCount(): number {
    if (!this.keepSelectionOnPageChange) {
      return this._selectedKeys.length;
    }

    return this.crossPageSelectedKeys.size + this._selectedKeys.filter(key =>
      !this.crossPageSelectedKeys.has(key.toString())
    ).length;
  }

  rowClick(row: any, evt: any) {
    //selected
    this.setDefaultSeclected = false;  // set flag to false after the user clicked on the cell.
  }

  clearSelect() {
    this._selectedKeys.splice(0, this._selectedKeys.length);
    this._viewData.forEach(d => d.deSelect());

    if (!this.keepSelectionOnPageChange) {
      this.crossPageSelectedKeys.clear();
    }
  }

  // 手動觸發選擇變更事件
  triggerSelectionChange() {
    if (this.keepSelectionOnPageChange) {
      this.saveCrossPageSelection();
    }
    this.emitSelection();
  }

  /** 移除不在資料中的選取項目 */
  removeSelectNotInData() {
    var keeped = this._selectedKeys.filter(x => this._data.data.some(y => y[this.kendoGridSelectBy] == x));
    this._selectedKeys.splice(0, this._selectedKeys.length);
    keeped.forEach(x => this._selectedKeys.push(x));
    this._viewData.forEach(d => {
      d.deSelect()
      if (this._selectedKeys.some(x => x == d.data[this.kendoGridSelectBy])) {
        d.select()
      }
    });
  }
  isEdited = false;
  matMenuTimer: any;

  onTableCellClick(event: MouseEvent): void {
    const context = this.getTableCellContext(event);
    if (context) {
      this.onCellClick(context.row, context.column, !this.isSelectionManagedByCheckbox(context.column));
    }
  }

  onTableCellDblClick(event: MouseEvent): void {
    const context = this.getTableCellContext(event);
    if (context) {
      this.onCellDblClick(context.row, context.column, !this.isSelectionManagedByCheckbox(context.column), event);
    }
  }

  private isSelectionManagedByCheckbox(column: VisGridColumnComponent): boolean {
    return column instanceof VisGridCheckboxColumnComponent && column.selectOnCheck && !column.checkOnSelect;
  }

  private getTableCellContext(event: MouseEvent): { row: any, column: VisGridColumnComponent } | null {
    const target = event.target;
    const table = event.currentTarget as HTMLElement;
    if (!(target instanceof Element) || !table) {
      return null;
    }

    const cell = target.closest('td[data-vis-column-field][data-vis-row-index]') as HTMLElement;
    if (!cell || !table.contains(cell)) {
      return null;
    }

    const rowIndex = Number(cell.getAttribute('data-vis-row-index'));
    const field = cell.getAttribute('data-vis-column-field');
    if (!Number.isInteger(rowIndex) || rowIndex < 0 || !field) {
      return null;
    }

    const row = this._viewData?.[rowIndex]?.data;
    const column = this.childs?.find(item => item._field === field);
    return row && column ? { row, column } : null;
  }

  onCellDblClick(row: any, col: any, updateSelection: boolean = true, event?: MouseEvent) {
    clearTimeout(this.matMenuTimer);
    this.matMenuTimer = undefined;
    this.handleDblClick(row, col, updateSelection);
    this.cellDblClick.emit({
      isEdited: this.isEdited,
      dataItem: row,
      column: col,
      rowIndex: this._data.data.indexOf(row),
      event: event!
    });
  }

  handleDblClick(row: any, col: VisGridColumnComponent, updateSelection: boolean = true) {
    var index = this._data.data.indexOf(row);
    this.cellClick.emit({
      isEdited: this.isEdited,
      dataItem: row,
      column: col,
      rowIndex: index
    });
    var key = row[this.kendoGridSelectBy];
    if (updateSelection && this._selectable && !this._selectByCheckOnly) {
      if (this.multiselect) {
        if (this._selectedKeys.some(i => i == key)) {
          var spliceInd = this._selectedKeys.indexOf(key);
          //this.currentSelected.splice(spliceInd,1);
          this._selectedKeys.splice(spliceInd, 1);
          this.findViewData(key)?.deSelect();
        } else {
          //this.currentSelected.push(index)
          this._selectedKeys.push(key);
          this.findViewData(key)?.select();
        }
      } else {
        //this.currentSelected = [index];
        if (this._selectedKeys.length == 0) {
          this._selectedKeys.push(key);
          this.findViewData(key)?.select();
        } else if (this._selectedKeys[0] == key) {
          // 取消選取 => 診間歷史病歷double click[複製]會無反應，先拿除this.clearSelect()，未來若有影響其他功能在全面檢視 2024.1.18
          //this.clearSelect();
        } else {
          this.findViewData(this._selectedKeys[0])?.deSelect();
          this._selectedKeys[0] = key;
          this.findViewData(key)?.select();
        }
      }
      this.emitSelectionForDbl();
    }
    this.childs.forEach(c => c.rowClick(index, row));
  }

  //currentSelected = [];
  onCellClick(row: any, col: VisGridColumnComponent, updateSelection: boolean = true) {
    this.matMenuTimer = setTimeout(() => {
      var index = this._data.data.indexOf(row);
      this.cellClick.emit({
        isEdited: this.isEdited,
        dataItem: row,
        column: col,
        rowIndex: index
      });
      var key = row[this.kendoGridSelectBy];
      if (updateSelection && this._selectable && !this._selectByCheckOnly) {
        if (this.multiselect) {
          //取消選取
          if (this._selectedKeys.some(i => i == key)) {
            var spliceInd = this._selectedKeys.indexOf(key);
            //this.currentSelected.splice(spliceInd,1);
            this._selectedKeys.splice(spliceInd, 1);
            this.findViewData(key)?.deSelect();
          } else {
            //this.currentSelected.push(index)
            this._selectedKeys.push(key);
            this.findViewData(key)?.select();
          }
        } else {
          //this.currentSelected = [index];
          if (this._selectedKeys.length == 0) {
            this._selectedKeys.push(key);
            this.findViewData(key)?.select();
          } else if (this._selectedKeys[0] == key) {
            if (this.cancelable) {
              // 取消選取
              this.clearSelect();
            }

          } else {
            this.findViewData(this._selectedKeys[0])?.deSelect();
            this._selectedKeys[0] = key;
            this.findViewData(key)?.select();
          }
        }
        this.emitSelection();
      }
      this.childs.forEach(c => c.rowClick(index, row));
    }, this.selectionDblClickChange.observers.length == 0 ? 0 : 300);
  }

  emitSelection() {
    var selectedData = this._selectedKeys.map((k, ind) => {
      let item: any;
      for (let i = 0; i < this._data.data.length; i++) {
        let currentData = this._data.data[i];
        if (currentData[this.kendoGridSelectBy] === k) {
          item = currentData;
          break;
        }
      }
      return { dataItem: item };
    });
    let selected = { selectedRows: selectedData };
    this.selectionChange.emit(selected);
  }

  emitSelectionForDbl() {
    var selectedData = this._selectedKeys.map((k, ind) => {
      let item: any;
      for (let i = 0; i < this._data.data.length; i++) {
        let currentData = this._data.data[i];
        if (currentData[this.kendoGridSelectBy] === k) {
          item = currentData;
          break;
        }
      }
      return { dataItem: item };
    });
    let selected = { selectedRows: selectedData };
    this.selectionDblClickChange.emit(selected);
  }

  // getRowClasses(row: GridViewModel, rowIndex: number): string[] {
  //   const classes = [...(row?.classes || [])];
  //   if (row?.data && this.isRowSetChangeClass(row.data)) {
  //     classes.push(this.changeRowClass);
  //   }

  //   const customClass = this.rowClass ? this.rowClass(row?.data, rowIndex) : null;
  //   if (customClass instanceof Array) {
  //     classes.push(...customClass.filter(x => !!x));
  //   } else if (customClass) {
  //     classes.push(customClass);
  //   }

  //   return classes;
  // }

  // getRowTitle(row: GridViewModel, rowIndex: number): string | null {
  //   if (!this.rowTitle) {
  //     return null;
  //   }
  //   return this.rowTitle(row?.data, rowIndex) || null;
  // }

  // getGridCellTitle(row: GridViewModel, rowIndex: number, cellTitle: any): string | null {
  //   const rowTitle = this.getRowTitle(row, rowIndex);
  //   if (rowTitle) {
  //     return rowTitle;
  //   }
  //   return cellTitle === null || cellTitle === undefined ? null : cellTitle;
  // }

  setAll(checked: boolean, field: string, fireEvent: boolean = true) {
    this._data.data.forEach(d => {
      // 設定勾選
      if (field !== null) {
        d[field] = checked;
      }
      if (this.multiselect) {
        // 設定全選
        const spliceInd = this._selectedKeys.indexOf(d[this.kendoGridSelectBy]);
        if (spliceInd != -1) {
          this._selectedKeys.splice(spliceInd, 1);
          this.findViewData(d[this.kendoGridSelectBy])?.deSelect();
        }

        if (checked === true) {
          this._selectedKeys.push(d[this.kendoGridSelectBy])
          this.findViewData(this.kendoGridSelectBy)?.select();
        }
      }
    });
    if (fireEvent) {
      this.childs.forEach(c => {
        if (c instanceof VisGridCheckboxColumnComponent) {
          if (c.selectOnCheck) {
            this._data.data.forEach((d, i) => {
              c.rowClick(i, d)
            });
          }
          c.checkChanged.emit({ checked: checked, data: null })
        }
      });
    }
  }

  resetSelectStatus() {
    this.removeSelectNotInData();
    this.childs.forEach(c => {
      if (c instanceof VisGridCheckboxColumnComponent && this._selectByCheckOnly && !c._field.match(`id.*`)) {
        this._data.data.forEach(d => {
          if (d[c._field] == true) {
            this._selectedKeys.push(d[this.kendoGridSelectBy])
            this.findViewData(d[this.kendoGridSelectBy])?.select();
          }
        });
      }
    });
  }

  select(itemKey: any) {
    if (!this._selectedKeys.some(s => s == itemKey)) {
      this._selectedKeys.push(itemKey);
      this.findViewData(itemKey)?.select();
    }
  }

  selectSingle(itemKey: any, fireEvent: boolean = true): void {
    const previousKey = this._selectedKeys[0];
    const previousView = this.findViewData(previousKey);
    const selectedView = this.findViewData(itemKey);

    this._selectedKeys.forEach(key => {
      if (key != itemKey) {
        this.findViewData(key)?.deSelect();
      }
    });
    this._selectedKeys.splice(0, this._selectedKeys.length, itemKey);
    selectedView?.select();

    this.childs?.forEach(column => {
      if (column instanceof VisGridCheckboxColumnComponent && column.checkOnSelect) {
        if (previousView?.data) {
          column.rowClick(this._data.data.indexOf(previousView.data), previousView.data);
        }
        if (selectedView?.data && selectedView !== previousView) {
          column.rowClick(this._data.data.indexOf(selectedView.data), selectedView.data);
        }
      }
    });

    if (fireEvent) {
      this.emitSelection();
    }
  }

  someComplete(col: VisGridColumnComponent): boolean {
    if (this._data?.data == null) {
      return false;
    }
    if (col instanceof VisGridCheckboxColumnComponent) {
      if (col.someChecked != null) {
        return col.someChecked
      }
    }
    return this._selectedKeys.length > 0 && this._selectedKeys.length < this._data.data.length;
  }

  AllComplete(col: VisGridColumnComponent) {
    if (this._data?.data == null || this._data.data.length == 0) {
      return false;
    }
    if (col instanceof VisGridCheckboxColumnComponent) {
      if (col.allChecked != null) {
        return col.allChecked
      }
    }
    return this._selectedKeys.length == this._data.data.length;
  }

  checkPageBtn() {
    this._hasNext = this.hasNext();
    this._hasPrev = this.hasPrev();
    this._hasNextTen = this.hasNextTen();
    this._hasPrevTen = this.hasPrevTen();
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this._data.data, event.previousIndex, event.currentIndex);
    var datas = {
      preIndex: event.previousIndex,
      curIndex: event.currentIndex
    }
    this.cdkDragEnded.emit(datas);
  }

  /** 欄寬設定傳回component */
  @Output() columnResize = new EventEmitter<{ columnName: string, width: number }>();
  
  /** 設定欄寬調整 */
  onResizeColumn(event: MouseEvent, columnName: string) {
    event.preventDefault();
    const startX = event.pageX;
    // 取得當前欄位元素的初始寬度
    const thElement = (event.target as HTMLElement).parentElement;
    const startWidth = thElement ? thElement.offsetWidth : 0;
    let currentWidth = startWidth;
    const doDrag = (moveEvent: MouseEvent) => {
      currentWidth = startWidth + (moveEvent.pageX - startX);
      // 透過動態更新樣式或變數來改變寬度
      if (thElement) {
        thElement.style.width = `${currentWidth}px`;
      }
    };
    const stopDrag = () => {
      window.removeEventListener('mousemove', doDrag);
      window.removeEventListener('mouseup', stopDrag);
      this.columnResize.emit({
          columnName: columnName,
          width: currentWidth
        });
    };
    window.addEventListener('mousemove', doDrag);
    window.addEventListener('mouseup', stopDrag);
  }

  @Input()
  mouseOnInd: number;
  @Output()
  mouseOnIndChange = new EventEmitter<number>();
  mouseEnter(ind: number) {
    this.mouseOnInd = ind;
    this.mouseOnIndChange.emit(this.mouseOnInd)
  }
  mouseLeave(ind: number) {
    this.mouseOnInd = null;
    this.mouseOnIndChange.emit(this.mouseOnInd)
  }


  headerClick(column: VisGridColumnComponent) {
    console.log(column)
    if (column.sortable) {
      column.onSort();
      if (column.sortOrder == 'none') {
        // 其他欄位切回預設
        this.childs.forEach(x => {
          if (x.sortable && x != column) {
            x.setSortDefault();//.sortOrder = 'none'
          }
        });
        this.sort.emit({
          sortOrder: 'none',
          column: ''
        });

      } else {
        //其他欄位設定成無排序
        this.childs.forEach(x => {
          if (x.sortable && x != column) {
            x.sortOrder = 'none'
          }
        });
        this.sort.emit({
          sortOrder: column.sortOrder,
          column: column.field
        });
      }

    }

  }

  findViewData(key: any) {
    return this._viewData.find(x => x.data[this.kendoGridSelectBy] == key);
  }
  updateSelectedView() {
    if (this.selectedViewUpdateTimer != null) {
      return;
    }
    this.selectedViewUpdateTimer = setTimeout(() => {
      this.selectedViewUpdateTimer = null;
      this.updateSelectedViewNow();
    }, 0);
  }

  private cancelSelectedViewUpdate() {
    if (this.selectedViewUpdateTimer != null) {
      clearTimeout(this.selectedViewUpdateTimer);
      this.selectedViewUpdateTimer = null;
    }
  }

  private updateSelectedViewNow() {
    this._viewData?.forEach(x => {
      x.deSelect();
      if (this._selectedKeys.some(y => y == x.data[this.kendoGridSelectBy])) {
        x.select();
      }
      x.classes = x.classes.filter(y => y != this.changeRowClass);

      if (this._changeClassKeys.some(y => y == x.data[this.setChangeClassBy])) {
        x.classes.push(this.changeRowClass)
      }
    })
  }

  resetSort() {
    this.childs.forEach(x => {
      if (x.sortable) {
        x.setSortDefault();
      }
    });
  }

  /*** 取得當前選擇項目的總數量 */
  getSelectionCount(): number {
    if (this.keepSelectionOnPageChange) {
      return this.getCrossPageSelectionCount();
    } else {
      return this._selectedKeys.length;
    }
  }

  /*** 格式化選擇計數顯示文字 */
  getSelectionText(): string {
    const count = this.getSelectionCount();
    //return `➤ 已選${count}項`;
    return `已選${count}項`;
  }

  /*** 重設選擇計數快取 */
  resetSelectionCache() {
    this._cachedSelectionCount = 0;
    this._lastDataChange = 0;
  }


}
